const sliderItems = [
  {
    name: 'Обувь',
    desc: 'Кроссовки, кеды и повседневная обувь',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=A%20single%20pair%20of%20stylish%20white%20minimal%20sneakers%20placed%20on%20a%20clean%20soft%20mint%20pastel%20background%20minimal%20product%20photography%20with%20soft%20natural%20lighting%20from%20the%20left%20side%20simple%20elegant%20composition%20high%20detail%20modern%20aesthetic%20no%20text%20no%20watermark%20isolated%20product%20shot%20with%20subtle%20shadow&width=400&height=400&seq=yoybuy-cat-shoes-01&orientation=squarish',
  },
  {
    name: 'Худи / Свитеры',
    desc: 'Тёплые худи и свитеры на любой сезон',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=A%20cozy%20oversized%20cream%20beige%20hoodie%20neatly%20folded%20on%20a%20soft%20mint%20pastel%20surface%20minimal%20product%20photography%20soft%20natural%20daylight%20clean%20aesthetic%20no%20text%20no%20logos%20simple%20elegant%20composition%20with%20subtle%20fabric%20texture%20visible&width=400&height=400&seq=yoybuy-cat-hoodies-02&orientation=squarish',
  },
  {
    name: 'Футболки',
    desc: 'Базовые и дизайнерские футболки',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=A%20fresh%20white%20cotton%20t-shirt%20neatly%20folded%20on%20a%20soft%20mint%20pastel%20background%20minimal%20product%20photography%20soft%20natural%20lighting%20clean%20modern%20aesthetic%20no%20text%20no%20logos%20simple%20elegant%20composition&width=400&height=400&seq=yoybuy-cat-tshirt-03&orientation=squarish',
  },
  {
    name: 'Куртки',
    desc: 'Стильные куртки и верхняя одежда',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    img: 'https://readdy.ai/api/search-image?query=A%20stylish%20lightweight%20beige%20jacket%20hanging%20on%20a%20minimal%20wooden%20hanger%20against%20a%20soft%20mint%20pastel%20background%20editorial%20product%20photography%20soft%20natural%20lighting%20from%20above%20clean%20elegant%20aesthetic%20no%20text%20no%20logos%20beautiful%20simplicity&width=400&height=400&seq=yoybuy-cat-jacket-04&orientation=squarish',
  },
];

export default function CategorySlider() {
  return (
    <section className="py-14 md:py-20 bg-foreground-950">
      <div className="w-full px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-4 py-1.5 text-xs font-label font-semibold tracking-wider uppercase rounded-full border border-foreground-500/40 text-foreground-300">
              Популярное сейчас
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white max-w-lg">
            14 категорий товаров
          </h2>
        </div>

        <div className="flex gap-4 md:gap-6 overflow-x-auto pb-4 scrollbar-hide">
          {sliderItems.map((item) => (
            <a
              key={item.name}
              href={item.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex-shrink-0 w-[220px] md:w-[260px] group cursor-pointer"
            >
              <div className="bg-background-100 rounded-xl overflow-hidden">
                <div className="aspect-square overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.name}
                    title={item.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              <div className="mt-3 px-1">
                <h3 className="text-sm md:text-base font-semibold text-white group-hover:text-primary-300 transition-colors">
                  {item.name}
                </h3>
                <p className="text-xs md:text-sm text-foreground-400 mt-1">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}